import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logos/Logo.png";
import productData from "../data/productData";

const Header = ({ openModal }) => {
    const [openSubmenu, setOpenSubmenu] = useState(null);

    const linkClass = ({ isActive }) =>
        isActive ? "nav-link active" : "nav-link";

    // Function to close the navbar after clicking a link
    const closeNavbar = () => {
        const navbar = document.getElementById("navbarNav");
        if (navbar && navbar.classList.contains("show")) {
            document.querySelector(".navbar-toggler").click();
        }
    };

    return (
        <div className="container-fluid bg-light sticky-top">
            <nav className="navbar navbar-expand-md navbar-light px-lg-5">
                {/* Logo */}
                <NavLink className="navbar-brand" to="/" onClick={closeNavbar}>
                    <img
                        src={logo}
                        alt="Logo"
                        width="120"
                        height="50"
                        className="d-inline-block align-top"
                    />
                </NavLink>

                {/* Hamburger Toggle */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    style={{ border: "0.5px" }}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Navbar Links */}
                <div
                    className="collapse navbar-collapse justify-content-end backGround"
                    id="navbarNav"
                >
                    <ul
                        className={
                            window.innerWidth >= 768
                                ? "navbar-nav ps-2 ps-md-0"
                                : "navbar-nav ps-2 ps-md-0 border"
                        }
                    >
                        <li className="nav-item mx-2 typesBorder">
                            <NavLink className={linkClass} to="/" onClick={closeNavbar}>
                                Home
                            </NavLink>
                        </li>

                        <li className="nav-item mx-2 typesBorder">
                            <NavLink className={linkClass} to="/about" onClick={closeNavbar}>
                                About
                            </NavLink>
                        </li>

                        {/* Our Products Dropdown */}
                        <li className="nav-item dropdown mx-2 typesBorder">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="navbarDropdownMenuLink"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Our Products
                            </button>

                            {/* 👇 Fixed dropdown: prevents closing on submenu click */}
                            <ul
                                className="dropdown-menu backGround border border-bottom-0 rounded-0 mt-0 mt-md-3 p-0"
                                aria-labelledby="navbarDropdownMenuLink"
                                data-bs-auto-close="outside"
                            >
                                {Object.entries(productData).map(([categoryKey, category]) => (
                                    <li key={categoryKey} className="dropdown-submenu border-bottom">
                                        {/* Category button */}
                                        <button
                                            className="dropdown-item dropdown-toggle"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                // ✅ Fix: close submenu if same category clicked again
                                                if (openSubmenu === categoryKey) {
                                                    const submenuEl = e.currentTarget.nextElementSibling;
                                                    if (submenuEl && submenuEl.classList.contains("show")) {
                                                        submenuEl.classList.remove("show");
                                                    }
                                                    setOpenSubmenu(null);
                                                } else {
                                                    setOpenSubmenu(categoryKey);
                                                }
                                            }}
                                        >
                                            {category.title}
                                        </button>

                                        {/* Submenu */}
                                        <ul
                                            className={`dropdown-menu rounded-0 border-bottom-0 mt-0 mt-md-1 ms-4 ms-md-0 p-0 submenuType backGround ${
                                                openSubmenu === categoryKey ? "show" : ""
                                            }`}
                                        >
                                            {Object.entries(category.types).map(([typeKey, typeObj]) => (
                                                <li
                                                    key={typeKey}
                                                    className={window.innerWidth >= 768 ? "border-bottom" : "border-top"}
                                                >
                                                    <NavLink
                                                        className="dropdown-item"
                                                        to={`/products/${categoryKey}/${typeKey}`}
                                                        onClick={() => {
                                                            closeNavbar();
                                                            setOpenSubmenu(null);
                                                        }}
                                                    >
                                                        {typeObj.name}
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                ))}
                            </ul>
                        </li>

                        <li className="nav-item mx-2 typesBorder">
                            <NavLink className={linkClass} to="/gallery" onClick={closeNavbar}>
                                Gallery
                            </NavLink>
                        </li>

                        <li className="nav-item mx-2 typesBorder">
                            <NavLink
                                className={linkClass}
                                to="/qualityAssurance"
                                onClick={closeNavbar}
                            >
                                Quality Assurance
                            </NavLink>
                        </li>

                        <li className="nav-item mx-2 typesBorder">
                            <NavLink className={linkClass} to="/contact" onClick={closeNavbar}>
                                Contact
                            </NavLink>
                        </li>

                        {/* Open Modal Instead of Navigating */}
                        <li className="nav-item mx-lg-3 ms-2 ms-md-0 py-lg-0 py-2 py-md-0">
                            <button
                                type="button"
                                className="btn btn-brand"
                                onClick={() => {
                                    closeNavbar();
                                    openModal("Get a Quote", "form-quote");
                                }}
                            >
                                Get a Quote
                            </button>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
};

export default Header;
